import { render } from "./SeoRow.vue?vue&type=template&id=8dc89738"
import script from "./SeoRow.vue?vue&type=script&lang=js"
export * from "./SeoRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__